/** Allowed post-login destinations within Clarity One. */
export function sanitizeClarityOneRedirect(raw: string | null | undefined): string {
  const trimmed = (raw ?? "").trim();
  if (!trimmed.startsWith("/") || trimmed.startsWith("//")) return "/";
  const pathOnly = trimmed.split("?")[0] ?? trimmed;
  if (pathOnly === "/login" || pathOnly.startsWith("/auth/verify")) return "/";
  if (pathOnly === "/home" || pathOnly === "/") return pathOnly === "/home" ? "/home" : "/";
  if (pathOnly === "/wallet/kaleidescape") return "/wallet/kaleidescape";
  if (pathOnly === "/account" || pathOnly === "/account/statement") return pathOnly;
  if (pathOnly === "/service") return pathOnly;
  if (pathOnly === "/proposals" || pathOnly === "/documents" || pathOnly === "/invoices") {
    return pathOnly;
  }
  if (/^\/proposals\/\d+$/.test(pathOnly)) return pathOnly;
  // Return to shared markup after APPROVE → login.
  if (/^\/share\/[A-Za-z0-9_-]{16,96}$/.test(pathOnly)) return pathOnly;
  return "/";
}

export function clarityOneLoginUrlWithRedirect(targetPath: string): string {
  const dest = sanitizeClarityOneRedirect(targetPath);
  if (dest === "/") return "/login";
  return `/login?redirect=${encodeURIComponent(dest)}`;
}
